/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, Spin, Select, Form } from 'antd';
import { UploadCard } from 'components';
import { Card, Drawer, Input } from 'components/gyramais';
import { Modal } from 'components/sdk';
import {
  badesulPortfolios,
  // translateMonth,
} from 'utils';
import { useMutation, useQuery } from '@apollo/client';

import { useBusinessLoanContext } from 'contexts/BusinessLoanContext';
import { usePartnerActionsContext } from 'contexts/PartnerActionsContext';
import ME from './graphql/me.gql';
import SAVE_BUSINESS from './graphql/saveBusiness.gql';

const { useForm, Item } = Form;

const ByAnnualDrawer = ({ visible, onClose, onComplete }) => {
  const [form] = useForm();

  const { businessId, currentContext } = useBusinessLoanContext();
  const { checkActions } = usePartnerActionsContext();
  const onlyByAnnualBilling = checkActions(['show-only-bi-anual-billing']);

  const [alertStatementModal, setAlertStatementModal] = useState(false);
  // const [statementsValues, setStatementsValues] = useState([]);
  const [statementsFilesAlreadyAdded, setStatementsFilesAlreadyAdded] = useState([]);
  const [statementsFilesIds, setStatementsFilesIds] = useState([]);
  const [savingBadesc, setSavingBadesc] = useState(false);

  const [baseDate, setBaseDate] = useState();
  const baseYear = useMemo(() => Number(baseDate?.split('/')[2]), [baseDate]);

  const {
    data: {
      me: { currentBusiness: { revenueStatementValues = [], additionalInfo } = {} } = {},
    } = {},
    loading: loadingMe,
  } = useQuery(ME, {
    onCompleted: ({ me }) => {
      const revenueStatements = me.currentBusiness.revenueStatement ?? [];

      if (revenueStatements[0]) {
        setStatementsFilesAlreadyAdded(revenueStatements);
        setStatementsFilesIds(revenueStatements.map(({ id }) => id));
      }
    },
  });

  const [saveBusiness, { loading: loadingSaveBusiness }] = useMutation(SAVE_BUSINESS, {
    onCompleted: () => {
      setSavingBadesc(true);
      onComplete();
    },
    onError: () => {
      setSavingBadesc(false);
    },
  });

  const isBadesul = badesulPortfolios.includes(currentContext?.loan?.portfolioName);
  const isBadesulMpe = currentContext?.loan?.portfolioName === 'Badesul MPE';
  // const isBadesulMpe = false;

  const validateStatements = (statementsValues) => {
    // needs 7 statementsValues with value
    const values = Object.values(statementsValues);
    const statementsWithValue = values.filter((value) => Boolean(Number(value)));
    const isFully = values.length === statementsWithValue.length;
    if (!isFully && statementsWithValue.length < 7) {
      return false;
    }

    const files = statementsFilesIds.length;
    if (!files) {
      // Sei que tem como escrever com menos linhas, só que assim fica mais legível :)
      return false;
    }

    return true;
  };

  const handleRevenueStatement = async () => {
    const statementsValues = form.getFieldsValue();

    const isStatementsValid = validateStatements(statementsValues);
    if (isStatementsValid) {
      const statementsKeys = Object.keys(statementsValues);
      const finalStatementsValues = statementsKeys.map((key) => ({
        value: statementsValues[key],
        mesano: key,
        reference: new Date(key.substring(2), Number(key.substring(0, 2) - 1)),
      }));

      saveBusiness({
        variables: {
          id: businessId || currentContext.business.id,
          revenueStatementFilesIds: statementsFilesIds,
          revenueStatementValues: finalStatementsValues,
          revenueStatementBaseDate: baseDate,
        },
      });
      return true;
    }

    return setAlertStatementModal(true);
  };

  const loading = loadingMe || loadingSaveBusiness || savingBadesc;

  const baseDateOptions = useMemo(() => {
    const currentYear = new Date().getFullYear() - 1;
    const stopOnYear = 2010;

    const options = [];

    for (let year = currentYear; year >= stopOnYear; year -= 1) {
      const date = `12/31/${year}`;

      options.push(date);
    }
    if (additionalInfo?.revenueStatementBaseDate) {
      setBaseDate(additionalInfo?.revenueStatementBaseDate);
    } else {
      setBaseDate(options[0]);
    }
    return options;
  }, [setBaseDate, additionalInfo]);

  const months = isBadesulMpe
    ? {
        12: 'Dezembro',
      }
    : {
        1: 'Janeiro',
        2: 'Fevereiro',
        3: 'Março',
        4: 'Abril',
        5: 'Maio',
        6: 'Junho',
        7: 'Julho',
        8: 'Agosto',
        9: 'Setembro',
        10: 'Outubro',
        11: 'Novembro',
        12: 'Dezembro',
      };
  const years = isBadesulMpe ? 2 : 1;

  useEffect(() => {
    const _revenueStatements = revenueStatementValues ?? [];
    const statements = [];

    for (const monthKey in months) {
      if (Object.hasOwn(months, monthKey)) {
        const mesano = monthKey;
        const statement = _revenueStatements.find(
          ({ mesano: statementMesano }) => statementMesano === mesano,
        );

        statements.push({
          [monthKey]: statement?.value || 0,
        });
      }
    }

    form.setFieldsValue({
      ...statements.reduce((acc, curr) => ({ ...acc, ...curr }), {}),
    });
  }, [form, baseDate]);

  return (
    <>
      <Drawer
        title="Faturamento"
        visible={visible}
        primaryButton={{
          children: 'Confirmar',
          onClick: handleRevenueStatement,
          loading,
        }}
        onClose={() => onClose()}
        closable={!onlyByAnnualBilling}
        maxWidth="100%"
        drawerStyle={
          onlyByAnnualBilling
            ? {
                width: 'calc(100% - 76px)',
              }
            : {}
        }
      >
        <Spin spinning={loading}>
          <Card className="statements-inputs-card">
            <Row align="middle" className="statement-input-area">
              <Col xs={24} sm={24} md={12}>
                <div className="statment-label">Data base</div>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Select
                  className="gyramais-input"
                  value={baseDate}
                  onChange={async (value) => {
                    setBaseDate(value);
                  }}
                >
                  {baseDateOptions.map((date) => {
                    const [month, day, year] = date.split('/');
                    return (
                      <Select.Option key={date} value={date}>
                        {day}/{month}/{year}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Col>
            </Row>

            <br />
            <Form form={form}>
              {Array(years)
                .fill('')
                .map((_, index) => (
                  <>
                    {baseDate &&
                      Object.keys(months).map((month) => (
                        <Row
                          align="middle"
                          key={`${month}${baseYear - index}`}
                          className="statement-input-area"
                          gutter={[24, 24]}
                        >
                          <Col xs={24} sm={24} md={12}>
                            <div className="statment-label">
                              {isBadesulMpe
                                ? `Valor total em ${Number(baseDate.split('/')[2]) - index}`
                                : `Valor em ${months[month]} de ${
                                    Number(baseDate.split('/')[2]) - index
                                  }`}
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Item
                              name={`${month}${baseYear - index}`}
                              className="statement-input-item"
                            >
                              <Input type="currency" />
                            </Item>
                          </Col>
                        </Row>
                      ))}
                  </>
                ))}
            </Form>
          </Card>

          <br />
          <br />
          <br />

          <UploadCard
            id="revenue-statement-upload"
            accept="application/pdf, .pdf"
            actualFile={statementsFilesAlreadyAdded}
            alert={
              isBadesulMpe
                ? 'Podendo ser aceito DRE constante no SPED Contábil acompanhado de seu Recibo ou PGDAS (Programa Gerador do Documento de Arrecadação do Simples Nacional Declaratório)'
                : false
            }
            multiples
            label={
              isBadesulMpe
                ? 'Comprovante fiscal de faturamento dos últimos dois anos'
                : 'DASN ou PGDAS ou SPED - Sistema Público de Escrituração Digital Contábil ou SIMEI, conforme o caso'
            }
            validateSignature={!isBadesul}
            onCompleted={async ({ id }) => {
              setStatementsFilesIds((ids) => [...ids, id]);
            }}
            onDelete={async ({ id }) => {
              setStatementsFilesIds((ids) => ids.filter((index) => index !== id));
            }}
          />
        </Spin>
      </Drawer>

      <Modal
        visible={alertStatementModal}
        okButton={{
          text: 'Voltar e preencher',
          onClick: () => setAlertStatementModal(false),
        }}
        title="OPS!!!"
        closable={false}
      >
        <p>
          Parece que você não preencheu todos os campos necessários para continuar sua solicitação.
          Confira se {isBadesul ? 'os últimos 7' : 'todos os'} meses de faturamento foram
          preenchidos corretamente e clique em CONFIRMAR.
          <br />
          <br />
          Lembrete: Para ter acesso ao crédito as empresas precisam ter, no mínimo, sete meses de
          faturamento.
          <br />
          <br />
          Em caso de dúvida, peça apoio ao Suporte.
        </p>
      </Modal>
    </>
  );
};

export default ByAnnualDrawer;
